export function registerSeenHandlerOnElement(observedRootElement: HTMLElement, seenHandlerCallback: () => void) {
	if (window.IntersectionObserver) {
		const observer = new window.IntersectionObserver(
			(e, o) => {
				const entry = e[0];
				if (entry?.isIntersecting) {
					o.unobserve(observedRootElement);
					seenHandlerCallback();
				}
			},
			{ threshold: 0.75 },
		);
		observer.observe(observedRootElement);
	}
}
